import { ReactComponent as CheckSVG } from 'assets/images/check.svg'

import { Step, StepList, StepProgressBarWrapper } from './styled'

type Step = {
  label: string
  isActive: boolean
  isCompleted: boolean
  isSkiped?: boolean
  dashed?: boolean
}

export type StepProgressBarProps = {
  steps: Step[]
}

export function ContestProgressBar({
  steps
}: StepProgressBarProps): JSX.Element {
  return (
    <StepProgressBarWrapper>
      <StepList>
        {steps.map(({ label, isActive, isCompleted, isSkiped, dashed }, i) => (
          <Step
            key={i}
            isActive={isActive}
            isCompleted={isCompleted}
            isSkiped={isSkiped}
            dashed={dashed}
          >
            <label className="step-title">Passo {i + 1}</label>
            <label className="step-descr">{label}</label>
          </Step>
        ))}
      </StepList>
    </StepProgressBarWrapper>
  )
}
